import React from "react";
import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import CardView from "../../../../../components/common/CardView";
import Search from "../../../../../components/Search";
import Table from "../../../../../components/Table";
import withRouter from "../../../../../withRouter";
import MonetizationRequestPresenter from "./MonetizationRequestPresenter";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import DateRangePicker from "../../../../../components/common/DateRangePicker";
import InputFactory from "../../../../../components/InputFactory";

class MonetizationRequestPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new MonetizationRequestPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      status: [],
      filteredStatus: "",
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const status = await findObjectUseCase().execute("monetization_request");
    this.setState({ status });
  }

  getCollectionName() {
    return "monetization_request";
  }

  // delete function
  async handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute(
      "monetization_request",
      id
    );
    this.refetchData();
  }

  // edit function
  async handleEditData(obj) {
    this.navigateTo(`/form/${this.getCollectionName()}/${obj.id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  // onChangeOption(field, value) {
  //   this.setState({ [field]: value });
  //   if (field === "filteredStatus") {
  //     this.onChangeFilter("String", value, "stats");
  //   }
  // }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  getcurrent() {
    return this.getCurrentUser().employee;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;

    console.log("OBJ: ", objects);

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-6 d-flex mt-1">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <InputFactory
                          key={field}
                          className="ms-1"
                          type={type}
                          field={field}
                          where={{}}
                          onChange={this.onChangeFilter.bind(this, type)}
                          {...options}
                        />
                      );
                    })}
                  </div>
                  <div className="col-md-3 mt-1">
                    <DateRangePicker
                      fields={["createdAt", "updatedAt", "employee.id"]}
                      onFilter={(filterObj) => {
                        // this.searchSubmit(filterObj);
                        if (Object.keys(filterObj).length > 0) {
                          const updatedAtDate = new Date(
                            filterObj.updatedAt.$lte
                          );
                          updatedAtDate.setDate(updatedAtDate.getDate() + 1);

                          const updatedFilterObj = {
                            ...filterObj,
                            updatedAt: {
                              $lte: updatedAtDate.toISOString().split("T")[0],
                            },
                          };
                          this.searchSubmit(updatedFilterObj);
                        } else {
                          this.searchSubmit(filterObj);
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                // objectId={this.handleDeleteData.bind(this)}
                progress={loading}
                objectData={this.handleEditData.bind(this)}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "updatedAt", "supervisor"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(MonetizationRequestPage);
